import Layout from "@/components/Layout";
import CMSPage from "@/pages/CMSPage";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CategoryThemeProvider } from "@/context/CategoryThemeContext";
import { LocationProvider } from "@/context/LocationContext";
import Home from "@/pages/Home";
import VendorList from "@/pages/VendorList";
import VendorProfile from "@/pages/VendorProfile";
import Favorites from "@/pages/Favorites";
import MyEvent from "@/pages/MyEvent";
import Notifications from "@/pages/Notifications";
import MyEnquiries from "@/pages/MyEnquiries";
import EnquiryDetail from "@/pages/EnquiryDetail";
import MyBookings from "@/pages/MyBookings";
import BookingDetail from "@/pages/BookingDetail";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Profile from "@/pages/Profile";
import VendorDashboard from "@/pages/vendor/VendorDashboard";
import VendorOnboarding from "@/pages/vendor/VendorOnboarding";
import VendorLanding from "@/pages/vendor/VendorLanding";
import VendorSubscriptionCheckout from "@/pages/vendor/VendorSubscriptionCheckout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import EmployeeLogin from "@/pages/employee/EmployeeLogin";
import EmployeeDashboard from "@/pages/employee/EmployeeDashboard";

function App() {
  return (
    <AuthProvider>
      <LocationProvider>
        <CategoryThemeProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/search" element={<VendorList />} />
              <Route path="/category/:slug" element={<VendorList />} />
              <Route path="/vendor/dashboard" element={<VendorDashboard />} />
              <Route path="/vendor/:slug" element={<VendorProfile />} />
              <Route path="/favorites" element={<Favorites />} />
              <Route path="/my-event" element={<MyEvent />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/enquiries" element={<MyEnquiries />} />
              <Route path="/enquiries/:id" element={<EnquiryDetail />} />
              <Route path="/bookings" element={<MyBookings />} />
              <Route path="/bookings/:id" element={<BookingDetail />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/vendor" element={<VendorDashboard />} />
              <Route path="/vendor/join" element={<VendorLanding />} />
              <Route path="/vendor/onboarding" element={<VendorOnboarding />} />
              <Route path="/vendor/subscription/checkout" element={<VendorSubscriptionCheckout />} />
              <Route path="/vendor/bookings" element={<VendorDashboard />} />
              <Route path="/vendor/leads/:id" element={<EnquiryDetail vendorView />} />
              <Route path="/employee/login" element={<EmployeeLogin />} />
              <Route path="/employee/dashboard" element={<EmployeeDashboard />} />
              <Route path="/employee/vendors/new" element={<VendorOnboarding employeeMode />} />
              <Route path="/employee/vendors/:vendorId/onboarding" element={<VendorOnboarding employeeMode />} />
              <Route path="/mmep-control" element={<AdminDashboard />} />
            <Route path="/:slug" element={<Layout><CMSPage /></Layout>} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </CategoryThemeProvider>
      </LocationProvider>
    </AuthProvider>
  );
}

export default App;
